import React, { useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import ElogInput from "../../common/form/ElogInput";

const calculateProfit = (buySum: number | undefined, saleSum: number | undefined): number => {
    if (buySum !== undefined && saleSum !== undefined) {
        const profit = saleSum - buySum;
        return parseFloat(profit.toFixed(2));
    }
    return 0;
};

interface ProfitInputProps {
    label: string;
}

const ProfitInput: React.FC<ProfitInputProps> = ({ label }) => {
    const [profitField, , { setValue }] = useField<number>('profit');
    const [buySumField] = useField<number>('buySum');
    const [saleSumField] = useField<number>('saleSum');
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        if (buySumField?.value == null || saleSumField?.value == null) return;
        const buySumValue = buySumField.value;
        const saleSumValue = saleSumField.value;
        const profitValue = calculateProfit(buySumValue, saleSumValue);
        setValue(profitValue);
        setFieldValue('profit', profitValue);
    }, [buySumField?.value, saleSumField?.value, setValue, setFieldValue]);

    return (
        <ElogInput label={label} name="profit" type="number" mandatory={false} />
    );
};

export default ProfitInput;